import { Container } from '@/atoms';
import { ContentImage } from '@/molecules';

import { isBotonContacto, useBotonContacto } from '@/hooks/useBotonContacto';
import {
  blockSpacing,
  eyebrowClass,
  sectionBgProps,
  textStyleClass,
} from '@/utils';
import { getRealUrl } from '@/utils/utils';

/**
 * ComponentRevisadasContenidoConImagen
 */
export const ComponentRevisadasContenidoConImagen = ({
  Eyebrow,
  Titulo,
  Subtitulo,
  Descripcion,
  EyebrowEstilo,
  TituloEstilo,
  SubtituloEstilo,
  DescripcionEstilo,
  Imagen,
  Ancla,
  Inverso,
  TipografiaSize,
  AlturaImagen,
  PosicionImagen,
  Forma,
  TamanoTitulo,
  Boton,
  FondoSeccion,
  Espaciado,
  Lista,
}: any) => {
  const { modal, abrirContacto } = useBotonContacto();
  const boton = Boton?.[0];
  // Un botón sin Tipo se oculta: antes de existir `Boton.Tipo` este bloque
  // sólo lo mostraba con `BotonTipo` relleno, y hay muchos botones guardados
  // que el editor nunca vio. El default "Link" cubre los nuevos.
  const hasContactForm = isBotonContacto(boton);
  const hasLink = !!boton && boton.Tipo === 'Link';
  const formaSvgUrl = Forma?.Svg?.url ? getRealUrl(Forma.Svg.url) : undefined;
  // Punto focal del recorte como dos % (X/Y, 0–100) → valor CSS object-position.
  // Si el bloque no los define (entradas antiguas), se queda en center.
  const imagePosition =
    Number.isFinite(PosicionImagen?.X) && Number.isFinite(PosicionImagen?.Y)
      ? `${PosicionImagen.X}% ${PosicionImagen.Y}%`
      : undefined;

  return (
    <>
      {hasContactForm && modal}

      <Container
        wrapper
        classNameWrapper={blockSpacing(Espaciado, 'py-6')}
        id={Ancla}
        {...sectionBgProps(FondoSeccion)}
      >
        <ContentImage
          eyebrow={Eyebrow}
          subtitle={Subtitulo}
          description={Descripcion}
          list={
            Lista?.Items?.length
              ? {
                  tipo: Lista.Tipo,
                  label: Lista.Label,
                  items: Lista.Items.map((it: any) => ({
                    text: it?.Texto,
                    icon: it?.Icono?.url
                      ? {
                          src: getRealUrl(it.Icono.url),
                          alt: it.Icono.alternativeText ?? '',
                        }
                      : undefined,
                  })),
                }
              : undefined
          }
          eyebrowStyleClass={eyebrowClass(EyebrowEstilo)}
          titleStyleClass={textStyleClass(TituloEstilo)}
          subtitleStyleClass={textStyleClass(SubtituloEstilo)}
          descriptionStyleClass={textStyleClass(DescripcionEstilo)}
          font={TipografiaSize}
          image={Imagen.map((img: any) => ({
            alt: img?.alternativeText,
            src: getRealUrl(img?.url),
          }))}
          title={Titulo}
          titleSize={TamanoTitulo}
          reverse={Inverso}
          imageHeight={AlturaImagen}
          imagePosition={imagePosition}
          imageShapeUrl={formaSvgUrl}
          isViewForms={hasContactForm}
          {...(hasContactForm && {
            button: {
              label: boton.Texto,
              variant: boton.Variante,
              onClick: () => abrirContacto(boton),
            },
          })}
          {...(hasLink && {
            link: {
              href: boton.Link || '#',
              type: 'button',
              label: boton.Texto,
              variant: boton.Variante,
            },
          })}
        />
      </Container>
    </>
  );
};

ComponentRevisadasContenidoConImagen.displayName =
  'ComponentRevisadasContenidoConImagen';
